import React from 'react';
import { motion } from 'framer-motion';
import '../AboutUs/about.css';
import Footer from '../Footer/Footer';

const About = () => {
    return (
        <div>
            <section className="section__container about__container" id="about">
                <motion.div 
                    className="about__content"
                    initial={{ x: -100, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ duration: 1 }}
                >
                    <h3>ABOUT US</h3>
                    <h2 className="section__header gradient-text">
                        ONE OF THE BEST REAL ESTATE AGENCIES IN NAVI MUMBAI
                    </h2>
                    <p className="section__subheader fade-in-text">
                        Whether you're a first-time homebuyer, a seasoned investor, or simply
                        looking for a change, we're here to guide you every step of the way.
                        Our mission is to make your real estate journey smooth and successful.
                    </p>

                    <motion.div 
                        className="owner-section glassmorph"
                        whileHover={{ scale: 1.02 }}
                        transition={{ type: 'spring', stiffness: 300 }}
                    >
                        <h3>Meet Our Owner</h3>
                        <h4>PRAVIN KALANTRE</h4>
                        <p>
                            With over 20 years of experience in the real estate industry, he is
                            dedicated to helping clients find their dream homes. His passion drives
                            our agency's mission to build lasting relationships based on trust and integrity.
                        </p>
                    </motion.div>

                    <div className="about__grid">
                        {[
                            { title: 'PROPERTIES', value: '50+' },
                            { title: 'YEARS EXPERIENCE', value: '15+' },
                            { title: 'ONGOING PROPERTIES', value: '12' }
                        ].map((card, index) => (
                            <motion.div
                                key={card.title}
                                className="about__card card-3d"
                                initial={{ y: 40, opacity: 0 }}
                                whileInView={{ y: 0, opacity: 1 }}
                                transition={{ duration: 0.6, delay: index * 0.2 }}
                                viewport={{ once: true }}
                            >
                                <h4>{card.title}</h4>
                                <p>{card.value}</p>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>

                <motion.div
                    className="about__image"
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 1 }}
                />
            </section>

            <Footer />
        </div>
    );
};

export default About;
